module.exports = __webpack_public_path__ + "img/and_interests.53c58c61.png";